import type { ApiClient } from './client';

/** ANX-063 — внутренняя заметка оператора в диалоге (видна только операторам). */
export interface ConversationNote {
  id: string;
  conversationId: string;
  operatorId: string;
  operatorName?: string;
  body: string;
  createdAt: string;
}

interface NoteRaw {
  id: string;
  conversation_id: string;
  operator_id: string;
  operator_name?: string;
  body: string;
  created_at: string;
}

function toNote(r: NoteRaw): ConversationNote {
  return {
    id: r.id,
    conversationId: r.conversation_id,
    operatorId: r.operator_id,
    operatorName: r.operator_name,
    body: r.body,
    createdAt: r.created_at,
  };
}

export async function listNotes(
  client: ApiClient,
  conversationId: string,
): Promise<ConversationNote[]> {
  const raw = await client.request<{ notes: NoteRaw[] }>(
    `/api/v1/conversations/${conversationId}/notes`,
  );
  return raw.notes.map(toNote);
}

export interface CreateNoteInput {
  body: string;
  mentionedOperatorIds?: string[];
}

export async function createNote(
  client: ApiClient,
  conversationId: string,
  input: CreateNoteInput,
): Promise<ConversationNote> {
  const json: Record<string, unknown> = { body: input.body };
  if (input.mentionedOperatorIds && input.mentionedOperatorIds.length > 0) {
    json.mentioned_operator_ids = input.mentionedOperatorIds;
  }
  const raw = await client.request<NoteRaw>(
    `/api/v1/conversations/${conversationId}/notes`,
    { method: 'POST', json },
  );
  return toNote(raw);
}
